// @ts-check
import * as sentry from "./sentry"

export const title = "Svend Walter"

let _apiBaseURL =
    typeof window !== "undefined" && window.localStorage?.getItem("apiBase")

export const apiBaseURL = _apiBaseURL || "/api/"
export const sentryDSN = ""
export const sentryTracingOrigins = [
    "localhost",
    apiBaseURL,
    // more api trace urls here
    /^\//,
]
export const sentryEnvironment = "master"

// need to execute early for fetch wrapping
// will be uncommented via drone CI
// sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment)
